module.exports = __webpack_public_path__ + "static/bluekush-3ae1c66acdd6749ff661ddb39c6759ca.jpg";